import { render, staticRenderFns } from "./StudiUser.vue?vue&type=template&id=2d8e9403"
import script from "./StudiUser.vue?vue&type=script&lang=js"
export * from "./StudiUser.vue?vue&type=script&lang=js"
import style0 from "./StudiUser.vue?vue&type=style&index=0&id=2d8e9403&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports